import components from "./components.json";
import views from "./views.json";

export const en = {
  components,
  views,
};
